export enum Formats {
  Date = 'Date',
  Datetime = 'Datetime',
  SimNao = 'SimNao',
  Function = 'Function',
  SlideToggle = 'SlideToggle',
  ComboBox = 'ComboBox',
  Currency = 'Currency',
  Number = 'Number',
  MinuteToHour = 'MinuteToHour',
  CheckBox = 'CheckBox',
  Image = 'Image',
  Button = 'Button',
  Renderer = 'Renderer',
}

export enum ExcelFormats {
  Currency = 'Currency',
  MinuteToHour = 'MinuteToHour',
  Function = 'Function',
  SimNao = 'SimNao',
}

export class Option {
  key: string;
  value: number;
  selected: boolean = false;

  constructor(key, value) {
    this.key = key;
    this.value = value;
  }

  public display(self: Option): string {
    return self?.key;
  }

  get displayWith() {
    return this.key;
  }
}

export class Coluna {
  columnDef: string;
  header: string;
  footer: string = '';
  calculateFooter: boolean = false;
  style: any = '';
  maxChars: number = 9999;
  display: boolean = true;
  export: boolean = true;
  format: Formats;
  excelFormat: ExcelFormats;
  function: any;
  editable: boolean = false;
  options: Option[];
  onChange: any = (event, element) => {};
  onBlur: any = (event, element) => {};
  accessFunction: string;
  accessFunctionRequired: boolean = false;
  link: string;
  target: string;
  routerLink: string | ((row: any) => string | any[]);
  routerLinkColumnDef: string;
  queryParams: any;
  sort: boolean = false;
  sortDirection: string = 'desc';
  decimals: number = 2;
  readonly: boolean = false;
  textAlign: string = 'left';
  width: string;
  flex: number;
  icon: string;
  totalType?: 'sum' | 'text';
  totalText?: string;
  renderer: any;
  responsive: boolean = true;
  neverHide: boolean = false;
  hidePriority: number = 0;
  minWidth: number = 120;
  detailOnly: boolean = false;

  constructor(object?) {
    var self = this;
    if (object) {
      Object.keys(object).forEach(function (k) {
        self[k] = object[k];
      });
    }
  }
}

export interface IdbaTableAction<T = any> {
  id: string;
  label: string;
  icon?: string;
  color?: string;
  tooltip?: string;
  routerLink?: (row: T) => string | any[];
  queryParams?: (row: T) => any;
  visible?: (row: T) => boolean;
  disabled?: (row: T) => boolean;
  execute?: (row: T) => void;
}

export interface IdbaTableBulkAction<T = any> {
  id: string;
  label: string;
  icon?: string;
  color?: string;
  enabled?: (rows: T[]) => boolean;
  execute: (rows: T[]) => void;
}

export interface IdbaTableSelectionConfig<T = any> {
  enabled: boolean;
  multiple?: boolean;
  showHeaderCheckbox?: boolean;
  selectPredicate?: (row: T) => boolean;
}
